"use client";
import CardsList from "@/components/cardsList";
import { LBGhoverEffect } from "styles/hoverPresets";
import { LEVELS_CONSTANTS } from "./constants";

const LevelsComponent = () => {
  return (
    <CardsList
      columns={{ base: 1, md: 2 }}
      list={LEVELS_CONSTANTS.list}
      spacing={{ base: 8, md: 12 }}
      title={LEVELS_CONSTANTS.title}
      hoverEffect
      hover={LBGhoverEffect}
    />
  );
};

export default LevelsComponent;
